<template>
  <div>
    <!-- HEARTBEAT SIMULATIONS PRESET-->
    <b-form-group
        description="Choose from different themes for the card images."
    >
      <drop-down-field
          field-name="Simulation Preset Selection:"
          field-key="preset"
          :options-json="optionsJSON"
          :selected-value="preset"
          select-word="Auto-Fills"
          @selected-option="handleOptionsSelect"
      />
    </b-form-group>
    <hr />
    <!-- VITALS -->
    <h5>Add Assessment</h5>
    <div style="
    padding: 25px;
    border-color: #ffc727;
    border-width: 3px;
    border-radius: 15px;
    border-style: dashed"
    >
      <b-form-group>
        <label-info
            id="heartbeat"
            label-name="Question"
            label-info=""
            :is-required="true"
        />
        <b-form-input
            type="text"
            required
            v-model="bodyTemp"
            @input="handleValueChange('simulation.bodyTemp', bodyTemp)"
            placeholder="What is the current situation with your heartbeat?"
        />
      </b-form-group>
      <b-form-group>
        <label-info
            id="heartbeat"
            label-name="Information
"
            label-info=""
            :is-required="true"
        />
        <b-form-input
            type="number"
            required
            v-model="bodyTemp"
            @input="handleValueChange('simulation.bodyTemp', bodyTemp)"
            placeholder=""
        />
      </b-form-group>
      <b-form-group
          description="Choose from different themes for the card images."
      >
        <drop-down-field
            field-name="Input Type:"
            field-key="preset"
            :options-json="optionsJSON"
            :selected-value="preset"
            select-word="Auto-Fills"
            @selected-option="handleOptionsSelect"
        />
      </b-form-group>
      <b-button
        pill
        variant="primary"
        class="float-right"
      >
        Add Assessment
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropDownField from "@/components/common/dropDownField";
import LabelInfo from "@/components/common/labelInfo";
import Editor from "@/components/common/editor";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import TheMask from "vue-the-mask/src/component";
import optionsJSON from "./assets/json/optionsJSON.json";
export default {
  name: "AddEditCarePlan_GeneralInfo",
  mixins: [UploadImage],
  components: {
    DropDownField,
    LabelInfo,
    Editor,
    ImageUpload,
    TheMask,
    VueBootstrapTypeahead
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    },
    storagePath:{
      type: String,
      default: 'careplans_care_plan_img'
    }
  },
  beforeMount() {},
  mounted() {
    this.setTypeAheads();
  },
  computed: {
    ...mapGetters({}),
    imgURL(){
      return this.form && this.form.imgURL ? this.form.imgURL : null;
    }
  },
  methods: {
    handleImgUploadedURL(idx, url) {
      this.handleValueChange('imgURL', url);
    },
    handleValueChange(key, value) { //mixin
      this.$emit('value-change', {key:key, value:value});
    },
    input(val) {
      this.$emit('value-change', {key:'description', value:val.content});
    },
    resetClear() {
      this.clear = false;
    },
    onContext(ctx) {
      this.context = ctx;
     // this.careplan_date_at = ctx.activeFormatted;
     //
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleCalendarDateSelected(date){
      this.$emit('value-change', {key:'careplan_date_at', value: date});
    },
    handleCalendarFocusClick(isFocused){
      this.calendar = isFocused;
    },
    setTypeAheads() {
      setTimeout(() => {
        //LANGUAGE
        if (
            this.language &&
            this.$refs.language
        ) {
          let languages = this.$typeAheadAboutsLanguage.filter(item => {
            return this.language == item.value;
          });

          this.$refs.language.$data.inputValue =
              languages.length > 0
                  ? languages[0].text
                  : this.language;
        }

        //TIMEZONE
        if (
            this.timezone &&
            this.$refs.timezone
        ) {
          let languages = this.$typeAheadAboutsLanguage.filter(item => {
            return this.timezone == item.value;
          });

          this.$refs.timezone.$data.inputValue =
              languages.length > 0
                  ? languages[0].text
                  : this.timezone;
        }

        //SPIRITUAL
        if (
            this.spiritual &&
            this.$refs.spiritual
        )
          this.$refs.spiritual.$data.inputValue = this.spiritual;

        //POLITICAL
        if (
            this.political &&
            this.$refs.political
        )
          this.$refs.political.$data.inputValue = this.political;

        //POLITICAL
        if (
            this.famRelationTo &&
            this.$refs.famRelationTo
        )
          this.$refs.famRelationTo.$data.inputValue = this.famRelationTo;

        }, 100);
    },
    handleOptionsSelect({key, option}){
      debugger;
      this[key] = option.value ? option.value : null;

      this.handleValueChange(`simulation.${key}`, this[key]);
    }
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
     const minDate = new Date(today)

    const maxDate = new Date(today)
    maxDate.setMonth(maxDate.getMonth() + 2)
    maxDate.setDate(15)
    return {
      optionsJSON,
      idx:0,
      production: true,
      verticalSpinDur: false,
      clear: false,
      description: null,
      calendar: false,
      context: null,
      calendarMin: minDate,
      calendarMax: maxDate,
      preset: this.form && this.form.simulation &&  this.form.simulation.preset ?
          this.form.simulation.preset : null,
      stage: this.form && this.form.simulation &&  this.form.simulation.stage ?
          this.form.simulation.stage : null,
      bodyTemp: this.form && this.form.simulation &&  this.form.simulation.bodyTemp ?
          this.form.simulation.bodyTemp : null,
      heartRate: this.form && this.form.simulation &&  this.form.simulation.heartRate ?
          this.form.simulation.heartRate : null,
      respRate: this.form && this.form.simulation &&  this.form.simulation.respRate ?
          this.form.simulation.respRate : null,
      bp: this.form && this.form.simulation &&  this.form.simulation.bp ?
          this.form.simulation.bp : null,
      oxygen: this.form && this.form.oxygen &&  this.form.simulation.oxygen ?
          this.form.simulation.oxygen : null,
      firstname: this.form && this.form.heartbeat &&  this.form.heartbeat.firstname ?
          this.form.heartbeat.firstname : null,
      lastname: this.form && this.form.heartbeat && this.form.heartbeat.lastname ?
          this.form.heartbeat.lastname : null,
      language:this.form && this.form.heartbeat && this.form.heartbeat.language ? this.form.heartbeat.language : null,
      timezone: this.form && this.form.heartbeat && this.form.heartbeat.timezone ?
          this.form.heartbeat.timezone : null,
      spiritual: this.form  && this.form.heartbeat && this.form.heartbeat.spiritual ?
          this.form.heartbeat.spiritual : null,
      political: this.form && this.form.heartbeat &&  this.form.heartbeat.political ?
          this.form.heartbeat.political : null,
      famFirstname: this.form && this.form.fam &&  this.form.fam.firstname ?
          this.form.fam.firstname : null,
      famLastname: this.form && this.form.fam && this.form.fam.lastname ?
          this.form.fam.lastname : null,
      famRelationTo: this.form && this.form.fam && this.form.fam.relationTo ?
          this.form.fam.relationTo : null,
      famLanguage: this.form && this.form.fam && this.form.fam.language ?
          this.form.fam.language : null,
      famTimezone: this.form && this.form.fam && this.form.fam.timezone ?
          this.form.fam.timezone : null,
      famSpiritual: this.form  && this.form.fam && this.form.fam.spiritual ?
          this.form.fam.spiritual : null,
      famPolitical: this.form && this.form.fam &&  this.form.fam.political ?
          this.form.fam.political : null,
      famEmail: this.form && this.form.fam && this.form.fam.email ?
          this.form.fam.email : null,
      famPhone: this.form && this.form.fam && this.form.fam.phone ?
          this.form.fam.phone : null,
      mainProps: {
        blank: false,
        blankColor: '#777',
        width: 200,
        height: 200,
        class: 'm1'
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.care-plan-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#care-plan_calender .btn-outline-info:hover,
#care-plan_calender .btn-outline-info:active,
#care-plan_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

